import { Table } from "antd";
import styled from "styled-components";

export const CenterColumns = styled.div`
  text-align: center;
  font-size: 1rem;
`;

export const CustomTable = styled(Table)`
  & button.ant-pagination-item-link {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
